import { c as _c } from "react/compiler-runtime";
import type { PublicTraceEntry, TraceIntegrationExecutionLog } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
import CollapsibleSection from '@/components/playbook-builder/components/collapsible-section';
import IntegrationLogTimelineItem from './components/integration-log-timeline-item';
export type IntegrationLogsSectionProps = {
  traceEntry: PublicTraceEntry;
};
const IntegrationLogsSection = t0 => {
  const $ = _c(11);
  const {
    traceEntry
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "details.logs"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("vault-proxy", t1);
  let t2;
  if ($[1] !== traceEntry.context) {
    t2 = traceEntry.context?.kind === "external_api" ? traceEntry.context.integrationLogs : [];
    $[1] = traceEntry.context;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const logs = t2;
  let t3;
  if ($[3] !== t) {
    t3 = t(_temp);
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== logs || $[6] !== t) {
    t4 = logs.length === 0 ? <div className="py-3 text-body-2 text-tertiary">{t(_temp2)}</div> : <div className="flex flex-col">{logs.map((log, i) => {
        const isFirst = i === 0;
        const isLast = i === logs.length - 1;
        return <IntegrationLogTimelineItem key={log.executionId} log={log} isLast={isLast} defaultShowDetails={isFirst} />;
      })}</div>;
    $[5] = logs;
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <CollapsibleSection title={t3} defaultOpen={true} className="px-4 pb-2 w-full">{t4}</CollapsibleSection>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};
export default IntegrationLogsSection;
function _temp($) {
  return $.title;
}
function _temp2($_0) {
  return $_0.empty;
}